var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-layout',{staticClass:"y-inner"},[_c('app-sider',[_c('app-menu')],1),_c('a-layout',[_c('app-header'),_c('app-content',[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }